import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import Button from '../Buttons';
import Icon from '../Icon';
import DayMonth from '../DayMonth';

const FormEvent = styled.form`
  font-size: ${rem('13px')};
  height: 100%;
  padding: ${rem('80px')} ${rem('30px')} ${rem('30px')} ${rem('30px')};
  position: relative;
`;

const DivFlex = styled.div`
  align-items: flex-end;
  display: flex;
`;

const DivCenter = styled.div`
  position: relative;
  top: 25%;
  transform: translateY(-25%);
`;

const DivScroll = styled.div`
  overflow-y: auto;
  padding-right: 1rem;
  width: calc(100% + 1.8rem);
  ${mediaqueries.greaterThan('mobile')`
    max-height: ${rem('350px')};
  `};
`;

const DayMonthEvent = styled(DayMonth)`
  width: 100%;
`;

const IconsEvent = styled(Icon)`
  flex: 0 0 ${rem('24px')};
  margin-right: 0.3rem;
  position: relative;

  ${mediaqueries.greaterThan('desktop')`
    flex: 0 0 ${rem('20px')};
  `};
`;

const IconEventClose = styled(Icon)`
  height: ${rem('18px')};
  position: absolute;
  right: ${rem('30px')};
  top: ${rem('30px')};
  width: ${rem('18px')};

  ${mediaqueries.greaterThan('desktop')`
    height: ${rem('16px')};
    left: ${rem('30px')};
    right: auto;
    top: ${rem('20px')};
    width: ${rem('16px')};
  `};
`;

const StrongMedium = styled.strong`
  font-family: ${props => props.theme.fonts.medium};
`;

const TitleEvent = styled.h3`
  font-size: ${rem('16px')};
  margin-bottom: ${rem('10px')};
  text-transform: none;
`;

const ElementEvent = styled.p`
  align-items: center;
  display: flex;
  font-size: inherit;
  line-height: 1.14;
  margin-bottom: ${rem('12px')};
`;

const DateEvent = ElementEvent.extend`
  align-items: flex-start;
  font-family: ${props => props.theme.fonts.medium};

  ${IconsEvent} {
    top: -${rem('4px')};
  }
`;

const DateRange = styled.time`
  display: block;
  margin-bottom: ${rem('5px')};
`;

const LinksEvent = styled.a`
  display: flex;
  font-family: ${props => props.theme.fonts.medium};
`;

const LinkNews = LinksEvent.extend`
  font-variant: small-caps;
  text-transform: lowercase;
`;

const WrapperButtons = styled.div`
  margin-top: ${rem('20px')};
`;

const EventButton = styled(Button)`
  background-color: ${props => props.theme.colors.grayDarkest};
  border: ${rem('2px')} solid ${props => props.theme.colors.grayDarkest};
  font-size: inherit;
  font-variant: small-caps;
  height: auto;
  margin-right: ${rem('20px')};
  padding: ${rem('6px')} 1.25rem;
  text-transform: lowercase;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${props => props.theme.colors.grayDarkest};
  }

  &:last-child {
    margin-right: 0;
  }

  ${props =>
    props.acceptedEvent &&
    `
      background-color: ${props.theme.colors.gray};
  `};
`;

const EventButtonInvested = EventButton.extend`
  background: none;
  border-color: inherit;
  color: ${props => props.theme.colors.grayDarkest};

  &:hover {
    color: ${props => props.theme.colors.light};
  }

  ${props =>
    props.rejectedEvent &&
    `
      color: ${props.theme.colors.gray};
  `};
`;

export {
  FormEvent,
  DivFlex,
  DivCenter,
  DivScroll,
  DayMonthEvent,
  IconsEvent,
  IconEventClose,
  StrongMedium,
  TitleEvent,
  ElementEvent,
  DateEvent,
  DateRange,
  LinksEvent,
  LinkNews,
  WrapperButtons,
  EventButton,
  EventButtonInvested
};
